import React from "react";
import { NavLink, Link } from "react-router-dom";

const SERIF = '"Cormorant Garamond", Georgia, serif';

const LINKS = [
  { label: "The Book", to: "/", end: true },
  { label: "Orientation & Support", to: "/offerings" },
  { label: "The Gallery", to: "/vault/gallery" },
  { label: "The Vault", to: "/vault" },
  { label: "Free Reset", to: "/somatic-reset" },
];

// Persistent top navigation for the secondary (non-reader) pages.
// theme: "light" (linen) for Offerings pages, "dark" (slate) for Vault/Gallery.
// `right` renders optional contextual controls on the far right of the bar.
export const SiteHeader = ({ theme = "light", right = null }) => {
  const dark = theme === "dark";
  const barStyle = dark
    ? { borderColor: "rgba(255,255,255,0.08)", background: "rgba(18,20,23,0.72)", backdropFilter: "blur(18px)" }
    : { borderColor: "rgba(60,46,30,0.12)", background: "rgba(243,239,234,0.82)", backdropFilter: "blur(18px)" };
  const brandColor = dark ? "#F7F5F0" : "#1E2229";
  const idle = dark ? "text-[#A3A8B2]" : "text-ink-soft";
  const hover = dark ? "hover:text-[#D4A373]" : "hover:text-terracotta";

  return (
    <header className="sticky top-0 z-40 border-b" style={barStyle} data-testid="site-header">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3.5 sm:px-8">
        <Link to="/" data-testid="site-header-brand" className="flex-none text-lg tracking-tight transition-opacity hover:opacity-80" style={{ fontFamily: SERIF, color: brandColor, fontWeight: 500 }}>
          Braced No More
        </Link>
        <nav className="flex min-w-0 flex-1 items-center justify-end gap-1 overflow-x-auto" data-testid="site-header-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`site-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-3 py-1.5 font-display text-[13px] transition-colors ${
                  isActive ? (dark ? "bg-[#D4A373] text-[#121417]" : "bg-ink text-ivory-50") : `${idle} ${hover}`
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          {right && <span className="ml-1.5 flex-none">{right}</span>}
        </nav>
      </div>
    </header>
  );
};
